module.exports = __webpack_public_path__ + "img/light.b73eb358.png";